import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import CompareView from '../components/layout/CompareView';
import { Spacer } from '../components/layout/Spacer';
import SimulationFilters from '../simulation/SimulationFilters';
import useLayoutAreaWatcher from '../simulation/watcher/useLayoutAreaWatcher';
import AnalyzeCompareLayoutView from './AnalyzeCompareLayoutView';
import { getAnalyzeTitle } from './analyzeCompare.helper';
import {
  analyzeCompareAnalyzeList,
  analyzeCompareIdByType,
  analyzeCompareViewModeSelected,
} from './analyzeCompare.state';

const AnalyzeCompareLayoutStages: React.FC = () => {
  const { t } = useTranslation('simulation');
  useLayoutAreaWatcher('simulation-area-view');
  const viewMode = useRecoilValue(analyzeCompareViewModeSelected);
  const analyzeList = useRecoilValue(analyzeCompareAnalyzeList);
  const firstAnalyzeId = useRecoilValue(analyzeCompareIdByType('first'));
  const secondAnalyzeId = useRecoilValue(analyzeCompareIdByType('second'));
  const firstAnalyzeListItem = _.find(
    analyzeList,
    a => a.analyzeId === firstAnalyzeId,
  );
  const secondAnalyzeListItem = _.find(
    analyzeList,
    a => a.analyzeId === secondAnalyzeId,
  );

  const firstTitle = firstAnalyzeListItem
    ? getAnalyzeTitle(firstAnalyzeListItem, t)
    : t`First analyse`;
  const secondTitle = secondAnalyzeListItem
    ? getAnalyzeTitle(secondAnalyzeListItem, t)
    : t`Second analyse`;
  const showFirst = viewMode !== 'second';
  const showSecond = viewMode !== 'first';

  const firstHeader = (
    <div className="flex w-full items-center">
      <div className="flex-1">{firstTitle}</div>
      <Spacer flexspace />
      <SimulationFilters />
    </div>
  );

  const secondHeader = (
    <div className="flex w-full items-center">
      <div className="flex-1">{secondTitle}</div>
      <Spacer flexspace />
    </div>
  );

  const firstContent = (
    <AnalyzeCompareLayoutView
      analyzeType="first"
      hideLayoutToolbar={showSecond}
    />
  );

  const secondContent = <AnalyzeCompareLayoutView analyzeType="second" />;

  return (
    <CompareView
      showFirst={showFirst}
      showSecond={showSecond}
      firstContentHeader={firstHeader}
      firstContent={firstContent}
      secondContentHeader={secondHeader}
      secondContent={secondContent}
      layoutToggle={true}
    />
  );
};

export default AnalyzeCompareLayoutStages;
